import * as Types from '../../../../../../../app.types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type GetCareGapFilterOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCareGapFilterOptionsQuery = (
  { __typename: 'Query' }
  & { getCareGapFilterOptions?: Types.Maybe<(
    { __typename: 'QMFilterOptions' }
    & { Gender?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, Age?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, Clinics?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, Divisions?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, Risk?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, CareGap?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, GapStatus?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, EngagementStatus?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, DiseaseAndTags?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, FutureAppointment?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, Languages?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, LineOfBusiness?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value' | 'parent'>
    )>>, Payers?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>>, CallAttemptCount?: Types.Maybe<Array<(
      { __typename: 'NameValue' }
      & Pick<Types.NameValue, 'name' | 'value'>
    )>> }
  )> }
);

export type AddFilterMutationVariables = Types.Exact<{
  input: Types.AddFilterInput;
}>;


export type AddFilterMutation = (
  { __typename: 'Mutation' }
  & { addFilter: (
    { __typename: 'Result' }
    & Pick<Types.Result, 'IsSuccess' | 'Message'>
  ) }
);


export const GetCareGapFilterOptionsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCareGapFilterOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCareGapFilterOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Gender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Age"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Clinics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Divisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CareGap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"GapStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"EngagementStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"DiseaseAndTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FutureAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"LineOfBusiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Payers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CallAttemptCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]};

/**
 * __useGetCareGapFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetCareGapFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareGapFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareGapFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCareGapFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCareGapFilterOptionsQuery, GetCareGapFilterOptionsQueryVariables>) {
        return Apollo.useQuery<GetCareGapFilterOptionsQuery, GetCareGapFilterOptionsQueryVariables>(GetCareGapFilterOptionsDocument, baseOptions);
      }
export function useGetCareGapFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareGapFilterOptionsQuery, GetCareGapFilterOptionsQueryVariables>) {
          return Apollo.useLazyQuery<GetCareGapFilterOptionsQuery, GetCareGapFilterOptionsQueryVariables>(GetCareGapFilterOptionsDocument, baseOptions);
        }
export type GetCareGapFilterOptionsQueryHookResult = ReturnType<typeof useGetCareGapFilterOptionsQuery>;
export type GetCareGapFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetCareGapFilterOptionsLazyQuery>;
export type GetCareGapFilterOptionsQueryResult = Apollo.QueryResult<GetCareGapFilterOptionsQuery, GetCareGapFilterOptionsQueryVariables>;
export function refetchGetCareGapFilterOptionsQuery(variables?: GetCareGapFilterOptionsQueryVariables) {
      return { query: GetCareGapFilterOptionsDocument, variables: variables }
    }
export const AddFilterDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IsSuccess"}},{"kind":"Field","name":{"kind":"Name","value":"Message"}}]}}]}}]};
export type AddFilterMutationFn = Apollo.MutationFunction<AddFilterMutation, AddFilterMutationVariables>;

/**
 * __useAddFilterMutation__
 *
 * To run a mutation, you first call `useAddFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFilterMutation, { data, loading, error }] = useAddFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFilterMutation(baseOptions?: Apollo.MutationHookOptions<AddFilterMutation, AddFilterMutationVariables>) {
        return Apollo.useMutation<AddFilterMutation, AddFilterMutationVariables>(AddFilterDocument, baseOptions);
      }
export type AddFilterMutationHookResult = ReturnType<typeof useAddFilterMutation>;
export type AddFilterMutationResult = Apollo.MutationResult<AddFilterMutation>;
export type AddFilterMutationOptions = Apollo.BaseMutationOptions<AddFilterMutation, AddFilterMutationVariables>;